/**
 * App Component
 * 
 * Root application component that provides global context and routing.
 */

import React from 'react';
import { GameProvider } from '@context';
import { GamePage } from './pages/GamePage';
import './styles/global.scss';

export const App: React.FC = () => {
  return (
    <GameProvider>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <main id="main-content">
        <GamePage />
      </main>
    </GameProvider>
  );
};